module.exports = __webpack_public_path__ + "img/43_33.cd2ffa27.png";